import { getJSON } from 'common/services/api'
import { NAMESPACE } from 'locale'
import { cqiConstants } from 'locale/cqi'
import { type TFunction, useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import BaseCQITable from './BaseCQITable'
import {
  CQI_BASE_URL,
  CQITabID,
  getRoundedPercentage,
  type TablesDataSource
} from './utils'

const CQI_WELL_LED_URL = `${CQI_BASE_URL}/well-led`

export type WellLedDataFetched = {
  carePlansReviewed: number
  carerProfilePictures: number
  activeUsersCount: number
}

const WellLedTable = () => {
  const { t } = useTranslation(NAMESPACE.CQI)

  const { data, isLoading } = useQuery<{ result: WellLedDataFetched }>(
    ['cqi', CQITabID.WellLed],
    () => getJSON({ url: CQI_WELL_LED_URL })
  )

  return (
    <BaseCQITable
      isLoading={isLoading}
      tabID={CQITabID.WellLed}
      dataSource={getWellLedData(t, data?.result)}
    />
  )
}

export const getWellLedData = (
  t: TFunction<string, undefined>,
  data: WellLedDataFetched | undefined
): TablesDataSource[] => {
  let carerProfilePicturesOutput: string | undefined
  let supportPlansReviewedPercentage: string | undefined

  if (
    data &&
    data?.carerProfilePictures !== undefined &&
    data?.activeUsersCount > 0
  ) {
    carerProfilePicturesOutput = `${data.carerProfilePictures}/${data.activeUsersCount}`
  }

  if (data && data?.carePlansReviewed !== undefined) {
    supportPlansReviewedPercentage = getRoundedPercentage(
      data.carePlansReviewed
    )
  }

  return [
    {
      key: t(cqiConstants.STAFF_WITH_PROFILE_PICTURES),
      indicator: t(cqiConstants.STAFF_WITH_PROFILE_PICTURES),
      timeframe: t(cqiConstants.PRESENT_TIME),
      output: carerProfilePicturesOutput
    },
    {
      key: t(cqiConstants.SUPPORT_PLANS_REVIEWED),
      indicator: t(cqiConstants.SUPPORT_PLANS_REVIEWED),
      timeframe: t(cqiConstants.SIX_MONTHS),
      output: supportPlansReviewedPercentage
    }
  ]
}

export default WellLedTable
